import { Badge } from "@/components/ui/badge";
import { Microscope, AlertTriangle } from "lucide-react";

const sev = {
  high: "bg-red-100 text-red-700 border-red-200",
  medium: "bg-amber-100 text-amber-700 border-amber-200",
  low: "bg-emerald-100 text-emerald-700 border-emerald-200",
};

export const DiseaseCard = ({ disease }) => (
  <div data-testid={`disease-card-${disease.diseaseName}`} className="rounded-2xl border border-black/5 bg-white overflow-hidden shadow-[0_8px_32px_rgba(0,0,0,0.04)]">
    <div className="grid grid-cols-2">
      <div className="relative">
        <img src={disease.early_image} alt="early stage" className="h-40 w-full object-cover" />
        <span className="absolute bottom-2 left-2 flex items-center gap-1 text-[10px] uppercase tracking-wider bg-black/60 text-white px-2 py-1 rounded-full"><Microscope className="w-3 h-3" /> Early Stage</span>
      </div>
      <div className="relative border-l-2 border-white">
        <img src={disease.severe_image} alt="severe damage" className="h-40 w-full object-cover" />
        <span className="absolute bottom-2 left-2 flex items-center gap-1 text-[10px] uppercase tracking-wider bg-black/60 text-white px-2 py-1 rounded-full"><AlertTriangle className="w-3 h-3" /> Severe Damage</span>
      </div>
    </div>
    <div className="p-6">
      <div className="flex items-center justify-between gap-2">
        <h4 className="font-serif text-2xl text-emerald-950">{disease.diseaseName}</h4>
        <Badge className={`rounded-full border ${sev[disease.severity]}`}>{disease.severity} risk</Badge>
      </div>
      <p className="mt-3 text-sm text-stone-600"><span className="font-semibold text-stone-800">Symptoms — </span>{disease.symptomsDescription}</p>
      <p className="mt-2 text-sm text-stone-600"><span className="font-semibold text-stone-800">Treatment protocol — </span>{disease.treatmentProtocol}</p>
    </div>
  </div>
);
